<template>
  <div class="mobile-admin-me-page">
    <van-nav-bar title="我的" fixed placeholder />

    <div class="page-content">
      <!-- 用户信息卡片 -->
      <div class="user-card">
        <div class="avatar">
          {{ avatarText }}
        </div>

        <div class="user-info">
          <div class="real-name">
            {{ user.realName || user.username || '管理员' }}
          </div>
          <div class="username">
            账号：{{ user.username || '-' }}
          </div>
          <div class="role-tag">
            管理员端
          </div>
        </div>
      </div>

      <!-- 快捷入口 -->
      <van-grid :column-num="2" clickable class="quick-grid">
        <van-grid-item
            icon="friends-o"
            text="学员管理"
            @click="$router.push('/m/admin/student')"
        />
        <van-grid-item
            icon="chart-trending-o"
            text="学情分析"
            @click="$router.push('/m/admin/learning-analysis')"
        />
      </van-grid>

      <!-- 账号信息 -->
      <van-cell-group inset class="cell-card">
        <van-cell title="账号" :value="user.username || '-'" />
        <van-cell title="姓名" :value="user.realName || '-'" />
        <van-cell title="角色" value="管理员" />
      </van-cell-group>

      <!-- 系统操作 -->
      <van-cell-group inset class="cell-card">
        <van-cell
            title="切换到电脑版"
            label="使用电脑端完整管理功能"
            is-link
            @click="switchToPc"
        />

        <van-cell
            title="退出登录"
            label="退出当前管理员账号"
            is-link
            class="logout-cell"
            @click="handleLogout"
        />
      </van-cell-group>

      <div class="version-text">
        众鑫驾校学习系统 · 管理员手机端
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant'
import { logout } from '@/api/auth'
import { removeToken } from '@/utils/auth'
import { setClientType } from '@/utils/device'

export default {
  name: 'MobileAdminMe',

  computed: {
    user() {
      return this.$store.state.userInfo || {}
    },

    avatarText() {
      const name = this.user.realName || this.user.username || '管'
      return name.substring(0, 1)
    }
  },

  methods: {
    async handleLogout() {
      try {
        await Dialog.confirm({
          title: '确认退出',
          message: '确定要退出当前管理员账号吗？',
          confirmButtonText: '退出登录',
          cancelButtonText: '取消'
        })

        try {
          await logout()
        } catch (e) {
          // 即使后端退出失败，也继续清理前端登录状态
        }

        removeToken()
        this.$store.commit('CLEAR_USER_INFO')

        Toast.success('已退出登录')
        this.$router.replace('/m/login')
      } catch (e) {
        // 用户取消
      }
    },

    switchToPc() {
      setClientType('pc')
      this.$router.replace('/admin/home')
    }
  }
}
</script>

<style scoped>
.mobile-admin-me-page {
  min-height: 100vh;
  background: #f5f7fa;
}

.page-content {
  padding: 12px 0 20px;
  box-sizing: border-box;
}

.user-card {
  margin: 0 12px 12px;
  padding: 18px 16px;
  background: #fff;
  border-radius: 14px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
}

.avatar {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: #1989fa;
  color: #fff;
  font-size: 26px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-info {
  margin-left: 14px;
  flex: 1;
  min-width: 0;
}

.real-name {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 6px;
}

.username {
  color: #606266;
  font-size: 13px;
  margin-bottom: 8px;
}

.role-tag {
  display: inline-block;
  padding: 3px 9px;
  border-radius: 999px;
  background: #ecf5ff;
  color: #1989fa;
  font-size: 12px;
}

.quick-grid {
  margin: 12px;
  border-radius: 12px;
  overflow: hidden;
}

.cell-card {
  margin-top: 12px;
}

.logout-cell {
  color: #ee0a24;
}

.version-text {
  text-align: center;
  color: #c0c4cc;
  font-size: 12px;
  margin-top: 22px;
}
</style>